import { useNavigate } from "react-router-dom";
import "./TicketCategory.scss";
import { useEffect, useState } from "react";
import { FiSearch } from "react-icons/fi";
import {
    DialogActions,
    Dialog,
    DialogTitle,
    DialogContent,
    Table,
    TableContainer,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    Paper
} from "@mui/material";
import { showToast } from "../../../toastService.js";
import { motion } from "framer-motion";
import Select from "react-select";
import AsyncSelect from "react-select/async";
import { customSelectStyles_dark, customSelectStyles_light } from "../../../components/ui/CustomSelect.jsx";
import { useSelector } from "react-redux";
import newRequest from "../../../utils/newRequest.js";
import { ScaleLoader } from "react-spinners";
import CircularButton, { CustomLoadingButton } from "../../../components/ui/CustomButton.jsx";
import { ToggleSwitch } from "../../../components/toogle/ToggleSwitch.jsx";
import ConfirmDialog from "../../../components/confirmDialog/confirmDialog.jsx";
import { MdAdd, MdClose, MdDelete, MdEdit, MdSave } from "react-icons/md";
import { useTranslation } from "react-i18next";

const TicketCategory = () => {
    const { t } = useTranslation();
    const { currentTheme } = useSelector((state) => state.theme);
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [isProcessing, setIsProcessing] = useState(false);
    const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);
    const [confirmDialogAction, setConfirmDialogAction] = useState("None");
    const [confirmationActiontext, setConfirmationActiontext] = useState("");
    const [isNotifyDialogOpen, setIsNotifyDialogOpen] = useState(false);
    const [notifyDialogTitle, setNotifyDialogTitle] = useState("Confirm");
    const [notifyDialogText, setNotifyDialogText] = useState("Text");
    const [searchTerm, setSearchTerm] = useState("");


    const handleConfirm = async () => {
        try {

        } catch (err) {
            console.log(err);
        }
        setIsConfirmDialogOpen(false);
    };


    return (
        <div>
            {isLoading ? (
                <div className="no-content">
                    <ScaleLoader
            color="var(--primary)"
            height={50}
            radius={8}
            width={4}
          />
                </div>
            ) : (
                <motion.div
                    className="ticket-category"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1, transition: { duration: 1 } }}
                    exit={{ opacity: 0, transition: { duration: 1 } }}
                >
                    <div className="ticket-navbar">
                        <div className="ticket-navbar-left">
                            <div className="homeSearch" style={{ width: "60%" }}>
                                <FiSearch className="homeSearchIcon" />
                                <input
                                    className="homeSearchInput"
                                    type="text"
                                    placeholder={t('search')}
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                />
                                {searchTerm?.length > 0 ? (
                                    <MdClose
                                        className="homeSearchClear"
                                        onClick={async () => setSearchTerm("")}
                                    />
                                ) : (
                                    <span className="homeSearchClearPlaceholder" />
                                )}
                            </div>
                        </div>
                        <div className="ticket-navbar-right">
                            <CustomLoadingButton
                                currentTheme={currentTheme}
                                iconPosition="end"
                                borderRadiusType="both"
                                variant="tint"
                                color="#0ea5a4"
                                tooltip={"Add new category"}
                                endIcon={<MdAdd />}
                                onClick={() => {
                                    try {

                                    } catch (error) {
                                        console.log(error);
                                    }
                                }}
                            >
                                {t('add')}
                            </CustomLoadingButton>
                            <CustomLoadingButton
                                currentTheme={currentTheme}
                                iconPosition="end"
                                borderRadiusType="both"
                                variant="tint"
                                color="#00D37F"
                                tooltip="Save changes"
                                endIcon={<MdSave />}
                                onClick={() => {
                                    try {

                                    } catch (error) {
                                        console.log(error);
                                    }
                                }}
                            >
                                {t('save')}
                            </CustomLoadingButton>
                        </div>
                    </div>
                    <div className="ticket-category-content">

                    </div>
                </motion.div>
            )}

            {/* Dialog to notify user about changes being saved */}
            <Dialog open={isNotifyDialogOpen}
                onClose={() => setIsNotifyDialogOpen(false)}
                PaperProps={{
                    sx: {
                        backgroundColor: currentTheme === "dark" ? "#181A20" : "#fff",
                        color: currentTheme === "dark" ? "#fff" : "#000",
                    },
                }}
                slotProps={{
                    backdrop: {
                        sx: {
                            backgroundColor: "rgba(0, 0, 0, 0.7)",
                        },
                    },
                }}>
                <DialogTitle>{notifyDialogTitle}</DialogTitle>
                <DialogContent>
                    <div dangerouslySetInnerHTML={{ __html: notifyDialogText }} />
                </DialogContent>
                <DialogActions>
                    <CustomLoadingButton currentTheme={currentTheme} variant="tint" color="#E040FB" onClick={() => setIsNotifyDialogOpen(false)}>{t('close')}</CustomLoadingButton>
                </DialogActions>
            </Dialog>
            {/* Confirm Dialog */}
            <ConfirmDialog
                isOpen={isConfirmDialogOpen}
                onClose={() => setIsConfirmDialogOpen(false)}
                onConfirm={handleConfirm}
                dialogTitle={t('confirmation')}
                dialogContent={<p dangerouslySetInnerHTML={{ __html: confirmationActiontext }} />}
            />
        </div>
    )
}

export default TicketCategory;